// extracted by mini-css-extract-plugin
export const portraitItem = "portrait-row-module--portrait--item--30Mhy";
export const portrait = "portrait-row-module--portrait--1LQ8w";
export const bg = "portrait-row-module--bg--1SHUc";
export const drips = "portrait-row-module--drips--7yqDE";
export const top = "portrait-row-module--top--1itBB";